// extracted by mini-css-extract-plugin
module.exports = {"policy-sidebar":"policy-sidebar_policy-sidebar__AFgSL","policy-sidebar--title":"policy-sidebar_policy-sidebar--title__NRk81"};